import axios from 'axios';
import qs from 'qs';
import { store } from '@/plugins/store';
import router from '@/router';

const axiosInstance = axios.create({
    baseURL: window.CONFIG.api.baseUrl || '',
});

axiosInstance.defaults.paramsSerializer = function (params) {
    return qs.stringify(params, { arrayFormat: 'repeat' });
};

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        // Masquer globalement les 401 et rediriger vers /login sans afficher d'erreur
        const status = error?.response?.status;
        const isPublicRequest = error?.config?.url?.includes('devis-validation') ||
            (error?.config?.url?.includes('/reclamations') && error?.config?.url?.includes('/note'));
        if (status === 401 && !isPublicRequest) {
            const currentPath = window.location.pathname + window.location.search;
            if (currentPath !== '/login' && currentPath !== '/') {
                localStorage.setItem('redirectAfterLogin', currentPath);
            }
            // Éviter les boucles de navigation
            if (window.location.pathname !== '/login') {
                router.push('/login');
            }
            return Promise.reject(error);
        }
        if (axios.isCancel && axios.isCancel(error)) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return new Promise(() => {});
        }
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.request.use(request => {
    const noAuthToken = localStorage.getItem('token_portail_partenaire') === null;
    const isAuthOrPublicEndpoint =
        !!request.url?.includes('/auth') ||
        request.url === '/demandes-comptes' ||
        request.url === '/demandes-comptes-fournisseur' ||
        (request.url?.includes('/reclamations') && request.url?.includes('/note')) ||
        request.url === '/noteReclamation' ||
        !!request.url?.includes('devis-validation');

    if (noAuthToken && !isAuthOrPublicEndpoint) {
        const currentPath = window.location.pathname + window.location.search;
        if (currentPath !== '/login' && currentPath !== '/') {
            localStorage.setItem('redirectAfterLogin', currentPath);
        }
        router.push('/login');
        // Annule immédiatement la requête pour éviter les 401 visibles
        return Promise.reject(new axios.Cancel('Unauthenticated - redirected to login'));
    }

    request.headers = request.headers || {};
    if (request.url?.includes('/reclamations') && request.url?.includes('/note')) {
        request.headers['Authorization'] = `Bearer  ${store.getters['noteReclamationState/getJwt'].toString()}`;
    } else if (request.url?.includes('devis-validation')) {
        delete request.headers['Authorization'];
    } else {
        const token = localStorage.getItem('token_portail_partenaire');
        const tokenAzure = localStorage.getItem('token_azure');
        if (token) {
            request.headers['Authorization'] = `Bearer ${token}`;
            if (tokenAzure) request.headers['Msal-Token'] = tokenAzure;
        }
    }
    request.headers['Ocp-Apim-Subscription-Key'] = window.CONFIG?.api?.apiSubscriptionKey || '';
    return Promise.resolve(request);
});

export { axiosInstance as http };
